'use client';

export { default } from './Icon';
export { default as iconClasses } from './iconClasses';
export * from './iconClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Icon/index.js
// module id = 853
// module chunks = 22